import React from "react";
import { Instructor } from "@/common/instructor/types";
import IndustryInsights from "@/components/ProgramDetailLayout/templates/NewDesign/components/IndustryInsights";
import InstructorList from "@/components/CourseContent/ContentRefresh/InstructorList";
import WhatYoullLearn from "@/components/CourseContent/ContentRefresh/WhatYoullLearn";
import BenefitList from "@/components/BenefitList";
import AccordionText from "@/components/AccordionText";
import AccordionTextItem from "@/components/AccordionText/AccordionTextItem";
import useTranslations from "@/i18n/useTranslations";

interface ProgramAccordionProps {
  // IndustryInsights props
  insights?: { value: string }[];

  // InstructorList props
  instructors?: Omit<Instructor, "aboutMe">[];
  showSingleColumn?: boolean;

  // WhatYoullLearn props
  learningItems?: {
    sortValue: number | null;
    value: string;
  }[];
  areLearningItemsRTL?: boolean;

  // WhyTakeProgram props
  benefits?: string[];
}

const ProgramAccordion = (props: ProgramAccordionProps) => {
  const t = useTranslations("Program");
  const tCommon = useTranslations("Common");
  const tCourse = useTranslations("Course");
  return (
    <div className="flex flex-col lg:grid lg:grid-cols-5 gap-6">
      {/* First Column - Accordions */}
      <div className="flex flex-col gap-6 lg:col-span-3">
        <AccordionText variant="value-oriented-content" title="">
          {props.learningItems && props.learningItems.length > 0 && (
            <AccordionTextItem
              variant="value-oriented-content"
              trigger={t("whatYoullLearn")}
            >
              <WhatYoullLearn
                key="whatYoullLearn"
                learningItems={props.learningItems}
                areLearningItemsRTL={props.areLearningItemsRTL}
                oneColumn={true}
              />
            </AccordionTextItem>
          )}

          {props.instructors && props.instructors.length > 0 && (
            <AccordionTextItem
              variant="value-oriented-content"
              trigger={tCourse("meetYourInstructors")}
            >
              <InstructorList
                instructors={props.instructors}
                showSingleColumn={true}
                hideTitle={true}
              />
            </AccordionTextItem>
          )}

          {props.insights && props.insights.length > 0 && (
            <AccordionTextItem
              variant="value-oriented-content"
              trigger={tCommon("industryInsights")}
            >
              <IndustryInsights
                insights={props.insights}
                hideTitle={true}
                oneColumn={true}
                disableExpand={true}
              />
            </AccordionTextItem>
          )}
        </AccordionText>
      </div>

      {/* Second Column - WhyTakeProgram */}
      {props.benefits && props.benefits.length > 0 && (
        <div className="flex flex-col gap-6 w-full lg:col-span-2">
          <BenefitList benefits={props.benefits} />
        </div>
      )}
    </div>
  );
};

export default ProgramAccordion;
